import { useEffect } from 'react';
import type { RefObject } from 'react';
import { followPointer } from './spot-follow';

/**
 * Polished-stone light that follows the mouse, `full` quality tier only (see `followPointer`). Touch,
 * pens, `lite` / `minimal` and reduced motion never subscribe: they keep the static highlights drawn
 * into the scene.
 */
export function useSpecularSpot(
  stage: RefObject<HTMLElement | null>,
  spot: RefObject<HTMLElement | null>,
  enabled: boolean,
): void {
  useEffect(() => {
    const host = stage.current;
    const light = spot.current;
    if (!enabled || !host || !light) return undefined;
    return followPointer(host, light);
  }, [stage, spot, enabled]);
}
